module.exports = __webpack_public_path__ + "static/media/fb-icon.33c88013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/icons/fb-icon.svg
// module id = 57
// module chunks = 0